<app-header></app-header>
<div class="pdf-cnt">
    <iframe [src]="getPdfToRender()" style="width:100%; height:100vh" frameborder="0"></iframe>
</div>